<h4>
  <span>
    <span [class]="healthClass">
      <fa-icon icon="heart" size="xs" class="mr-1"></fa-icon>
      <span *ngIf="hasScore">{{health}}</span>
      <span *ngIf="!hasScore">--</span>
    </span>
    &nbsp;
    <span [class]="armourClass">
      <span *ngIf="hasScore">{{armour}}</span>
      <span *ngIf="!hasScore">--</span>
      <fa-icon icon="shield" size="xs" class="ml-1"></fa-icon>
    </span>
  </span>
</h4>
